import type { FC } from "react";
import React from "react";
import translate from "src/lib/translate";
import InDialog from "src/ui/components/InDialog/InDialog";
import WaistCircumferenceForm from "src/ui/components/WaistCircumferenceForm/WaistCircumferenceForm";
import useGoToOrBack from "src/ui/hooks/useGoToOrBack";
import { AppQueryPopupsController } from "../AppQueryPopups/AppQueryPopupsBloc";
import { LoincCodingCode } from "src/constants/fhir";

const WaistCircumferenceDialog: FC<{
  returnUrl: string;
}> = ({ returnUrl }) => {
  const navigate = useGoToOrBack();

  const onClose = (dispatch?: boolean) => {
    AppQueryPopupsController.closePopup();
    if (dispatch) {
      document.dispatchEvent(
        new CustomEvent("dataSubmitted", {
          bubbles: true,
          detail: { loincCode: LoincCodingCode.waistCircumference }
        })
      );
    }
    navigate(returnUrl, {
      multiBack: true,
      replace: true
    });
  };

  return (
    <InDialog
      popup
      title={translate("upload_labs.waist_circumference.popupTitle")}
      returnUrl={returnUrl}
      onClose={onClose}
    >
      <nine-spacer s="md"></nine-spacer>

      <WaistCircumferenceForm onComplete={() => onClose(true)} />
    </InDialog>
  );
};

export default WaistCircumferenceDialog;
